<ng-container *ngIf="canImpersonate">
    <mat-form-field
        appearance="outline"
        class="organization-selector w-45 [&_.mat-mdc-form-field-wrapper]:pb-0 [&_.mat-mdc-form-field-wrapper]:mb-0 [&_.mat-mdc-form-field-flex]:h-9 [&_.mat-mdc-form-field-infix]:py-1"
        matTooltip="{{ tooltipKey | transloco }}"
        matTooltipPosition="below"
    >
        <input
            matInput
            [placeholder]="'organization.selector.choose_placeholder' | transloco"
            [formControl]="searchControl"
            [matAutocomplete]="orgAuto"
            (click)="onInputClick()"
            (focus)="onInputClick()"
            class="text-sm"
        />
        <mat-icon matPrefix [svgIcon]="'heroicons_outline:building-office-2'" class="!w-4 !h-4"></mat-icon>
        <mat-icon
            matSuffix
            [svgIcon]="'heroicons_outline:x-mark'"
            class="!w-4 !h-4 cursor-pointer text-gray-400 hover:text-gray-600"
            (click)="clearOrganizationSelection()"
            *ngIf="searchControl.value"
            [title]="'organization.selector.clear_selection' | transloco"
        >
        </mat-icon>
        <mat-autocomplete
            #orgAuto="matAutocomplete"
            [displayWith]="displayOrganization"
            (optionSelected)="onOptionSelected($event.option.value)"
        >
            <mat-option *ngFor="let org of filteredOptions | async" [value]="org">
                <ng-container *ngIf="org === null">{{ defaultOptionLabel() }}</ng-container>
                <ng-container *ngIf="org !== null">{{ org.name }}</ng-container>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
</ng-container>
